import imgCommercial from "../assets/images/home/hospitality/c1.jpg";
import imgResidential from "../assets/images/home/hospitality/c2.jpg";
import imgEntertainment from "../assets/images/home/hospitality/c3.jpg";
import imgHospitality from "../assets/images/home/hospitality/c4.png";
import projectShowcaseImg from "../assets/images/allprojects/project.jpg";

export const sectorDetailBySlug = {
  commercial: {
    slug: "commercial",
    title: "Commercial",
    subtitle: "Offices · Retail · Mixed-use",
    description:
      "Commercial spaces demand high-performance interiors that balance functionality, aesthetics, and compliance. From open-plan offices to retail showrooms, gypsum board solutions cover every surface, walls, ceilings, and facades, to deliver fast, flexible, and code-compliant construction.",
    about:
      "Commercial spaces demand high-performance interiors that balance functionality, aesthetics, and compliance. From open-plan offices to retail showrooms, gypsum board solutions cover every surface, walls, ceilings, and facades, to deliver fast, flexible, and code-compliant construction.",
    image: imgCommercial,
    benefits: {
      interiorWalls: [
        "Fire-rated partitions for code compliance",
        "Acoustic separation for offices and meeting rooms",
        "partition makes open space changes simple.",
        "Smooth, paint-ready finishes",
        "Thermal insulation to improve energy efficiency and reduce HVAC costs",
      ],
      ceilingSystems: [
        "Suspended ceilings for concealed MEP services",
        "Acoustic tile systems to reduce noise levels",
        "Fire-rated ceiling assemblies in high-occupancy floors",
        "Clean, modern aesthetic for lobbies and workspaces",
      ],
      exteriorCladding: [
        "Weather-resistant sheathing boards for facades",
        "Thermal insulation to reduce energy consumption",
        "Lightweight cladding for high-rise applications",
        "Durable finish substrate for renders and coatings",
      ],
    },
    project: {
      title: "Project title here - Display some of your projects",
      description:
        "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce.",
      image: projectShowcaseImg,
    },
  },
  residential: {
    slug: "residential",
    title: "Residential",
    subtitle: "Villas · Apartments · Private homes",
    description:
      "The home is where comfort, privacy, and safety converge. Residential construction requires materials that enhance everyday living across every surface, managing noise between rooms, regulating indoor temperatures, protecting moisture-prone areas, and creating beautiful exteriors that last.",
    about:
      "The home is where comfort, privacy, and safety converge. Residential construction requires materials that enhance everyday living across every surface, managing noise between rooms, regulating indoor temperatures, protecting moisture-prone areas, and creating beautiful exteriors that last.",
    image: imgResidential,
    benefits: {
      interiorWalls: [
        "Soundproofing between bedrooms and living areas",
        "Moisture-resistant boards for bathrooms and kitchens",
        "Fire protection for added household safety",
        "Thermal insulation for year-round comfort",
      ],
      ceilingSystems: [
        "Smooth plasterboard ceilings for elegant interiors",
        "Acoustic ceilings to reduce impact and airborne noise",
        "Moisture-resistant ceilings for bathrooms and kitchens",
        "Drop ceilings to conceal wiring and pipe runs",
      ],
      exteriorCladding: [
        "External wall insulation boards for energy efficiency",
        "Weather-resistant sheathing under render systems",
        "Lightweight solution for villa and apartment facades",
        "Resistance to humidity and outdoor temperature swings",
      ],
    },
    project: {
      title: "Project title here - Display some of your projects",
      description:
        "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce.",
      image: projectShowcaseImg,
    },
  },
  entertainment: {
    slug: "entertainment",
    title: "Entertainment",
    subtitle: "Cinemas · Theatres · Studios · lecture & conference hall",
    description:
      "Entertainment venues are defined by immersive experiences, and every surface plays a role. From the acoustic precision of a recording studio to the dramatic exterior of a concert hall, gypsum board systems deliver performance and design flexibility across walls, ceilings, and facades.",
    about:
      "Entertainment venues are defined by immersive experiences, and every surface plays a role. From the acoustic precision of a recording studio to the dramatic exterior of a concert hall, gypsum board systems deliver performance and design flexibility across walls, ceilings, and facades.",
    image: imgEntertainment,
    benefits: {
      interiorWalls: [
        "High-mass sound isolation between cinema screens",
        "Curved and shaped boards for architectural features",
        "Fire-rated partitions for public safety compliance",
        "Vibration-dampening assemblies for live venues",
      ],
      ceilingSystems: [
        "Acoustic ceiling panels for sound clarity and diffusion",
        "Shaped soffits and coffers for dramatic theatre aesthetics",
        "Integrated systems for lighting rigs and AV cabling",
        "Fire-rated assemblies for audience safety overhead",
      ],
      exteriorCladding: [
        "Facade sheathing for landmark entertainment buildings",
        "Impact and weather resistance for high-footfall exteriors",
        "Substrate for decorative renders and feature cladding",
        "Thermal performance for large-volume public buildings",
      ],
    },
    project: {
      title: "Project title here - Display some of your projects",
      description:
        "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce.",
      image: projectShowcaseImg,
    },
  },
  hospitality: {
    slug: "hospitality",
    title: "Hospitality",
    subtitle: "Hotels · Resorts · Restaurants",
    description:
      "In hospitality, every detail shapes the guest experience. Hotels, resorts, and restaurants require surfaces that look stunning, perform under intensive use, and meet strict safety codes, from the exterior facade that makes a first impression, to the ceiling above a guest's bed.",
    about:
      "In hospitality, every detail shapes the guest experience. Hotels, resorts, and restaurants require surfaces that look stunning, perform under intensive use, and meet strict safety codes, from the exterior facade that makes a first impression, to the ceiling above a guest's bed.",
    image: imgHospitality,
    benefits: {
      interiorWalls: [
        "Acoustic privacy between guest rooms and corridors",
        "Moisture-resistant boards for spas and wet areas",
        "Impact-resistant systems in service corridors",
        "Premium smooth finishes for luxury interiors",
      ],
      ceilingSystems: [
        "Decorative ceiling features for lobbies and restaurants",
        "Acoustic ceilings for banquet halls and event spaces",
        "Moisture-resistant ceilings for pool and spa areas",
        "Concealed service integration for a clean aesthetic",
      ],
      exteriorCladding: [
        "Facade systems for resort and hotel exteriors",
        "Weather and UV-resistant boards for warm climates",
        "Thermal cladding to reduce cooling loads in hot regions",
        "Smooth render base for high-end architectural finishes",
      ],
    },
    project: {
      title: "Project title here - Display some of your projects",
      description:
        "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce.",
      image: projectShowcaseImg,
    },
  },
  healthcare: {
    slug: "healthcare",
    title: "Healthcare",
    subtitle: "Hospitals · Clinics · Labs · operation theater",
    description:
      "Healthcare facilities operate under the most demanding building standards in the world. Every surface, from exterior walls to clinical ceilings, must support hygiene, patient wellbeing, infection control, and the complex functional requirements of modern medical environments.",
    about:
      "Healthcare facilities operate under the most demanding building standards in the world. Every surface, from exterior walls to clinical ceilings, must support hygiene, patient wellbeing, infection control, and the complex functional requirements of modern medical environments.",
    image: imgCommercial,
    benefits: {
      interiorWalls: [
        "Non-porous surfaces for infection control",
        "Lead-lined boards for X-ray and imaging rooms",
        "Impact-resistant systems for trolley and equipment zones",
        "Acoustic separation for patient privacy",
      ],
      ceilingSystems: [
        "Cleanable, hygienic ceiling tiles for clinical areas",
        "Moisture-resistant ceilings for sterile environments",
        "Acoustic ceilings for recovery wards and ICUs",
        "Integrated access panels for above-ceiling services",
      ],
      exteriorCladding: [
        "High-performance facade sheathing for large hospital complexes",
        "Thermal insulation to support energy-efficient operations",
        "Durable, low-maintenance exterior boards",
        "Fire-resistant cladding for multi-storey healthcare buildings",
      ],
    },
    project: {
      title: "Project title here - Display some of your projects",
      description:
        "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce.",
      image: projectShowcaseImg,
    },
  },
  education: {
    slug: "education",
    title: "Education",
    subtitle: "Schools · Universities · Libraries",
    description:
      "Learning environments need to be safe, focused, and inspiring. Drywall systems help manage acoustics, ensure fire safety, and create flexible, durable spaces that support students and staff, from the classroom walls and ceilings to the building's outer shell.",
    about:
      "Learning environments need to be safe, focused, and inspiring. Drywall systems help manage acoustics, ensure fire safety, and create flexible, durable spaces that support students and staff, from the classroom walls and ceilings to the building's outer shell.",
    image: imgResidential,
    benefits: {
      interiorWalls: [
        "Acoustic partitions between classrooms",
        "Fire-rated walls for student and staff safety",
        "Demountable systems for flexible room layouts",
        "Durable surfaces for high-footfall corridors",
      ],
      ceilingSystems: [
        "Acoustic ceilings for speech clarity in classrooms",
        "Impact-resistant tiles for sports halls and canteens",
        "Fire-rated ceiling assemblies across all zones",
        "Easy-access suspended ceilings for maintenance",
      ],
      exteriorCladding: [
        "Insulated facade systems for energy-efficient campuses",
        "Weather-resistant sheathing for all climates",
        "Low-maintenance exteriors to reduce long-term costs",
        "Fire-resistant cladding for multi-storey school buildings",
      ],
    },
    project: {
      title: "Project title here - Display some of your projects",
      description:
        "IRQGYP was founded with a clear mission: to modernize Iraq's construction industry through high-quality gypsum products and reliable technical expertise. Headquartered in Baghdad with operations in Erbil, we combine advanced production facilities with a skilled local workforce.",
      image: projectShowcaseImg,
    },
  },
};

export function getSectorDetailBySlug(slug) {
  if (!slug) return undefined;
  return sectorDetailBySlug[slug];
}
